// ----------------------------------------------------------------------
// <copyright file="Izenda.DateTimeConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

export default {
  Keys: {
    ENTER: 13,
    ESC: 27,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40
  },
  Units: {
    YEAR: 'years',
    MONTH: 'months',
    DAY: 'days',
    HOUR: 'hours'
  },
  Types: {
    JS_DATE: 'JS_DATE',
    MOMENT: 'MOMENT',
    ISO: 'ISO',
    STRING: 'STRING',
    TIME: 'TIME'
  },
  Levels: {
    years: {
      up: null,
      down: 'months',
      nav: {
        unit: 'years',
        span: 10
      },
      key: {
        unit: 'year',
        span: 1
      }
    },
    months: {
      up: 'years',
      down: 'days',
      nav: {
        unit: 'year',
        span: 1
      },
      key: {
        unit: 'month',
        span: 1
      }
    },
    days: {
      up: 'months',
      down: null,
      nav: {
        unit: 'month',
        span: 1
      },
      key: {
        unit: 'day',
        span: 1
      }
    },
    hours: {
      up: null,
      down: null,
      key: {
        unit: 'minutes',
        span: 30
      }
    }
  }
};



// WEBPACK FOOTER //
// ./ui/share/components/controls/DateTime/Izenda.DateTimeConstants.js